import {
  SimpleResourceCardController,
  SimpleResourceCardComponent
} from './simple_resource_card/simple_resource_card_controller';
/**
 * @phxResourceCard
 */

angular
  .module('ui-ng-resource-card', [])
  .controller('SimpleResourceCardController', SimpleResourceCardController)
  .component('simpleResourceCard', new SimpleResourceCardComponent());



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-resource-card/src/main.ts